import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Modal from '@mui/material/Modal';

const PurchaseReturnCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();
    const branchId = 0;


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState([]);

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, userId, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    useEffect(() => {
        fetchInvoicetypeData();
        fetchfrightrate();
        fetchStoreLocations();
    }, []);

    const [storeLocationOptions, setStoreLocationOptions] = useState([]);
    const [selectedStoreLocation, setSelectedStoreLocation] = useState(null);

    const fetchStoreLocations = () => {
        fetchData('StoreLocationApi', `/${companyId}`, token)
            .then((res) => {
                if (res.responseCode === '1111') setStoreLocationOptions(res.response_data);
            })
            .catch((err) => console.error('Error fetching store locations:', err));
    };

    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                    PaidAmount: 0,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('PurchaseApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    ClearingDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };


    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;

        // Calculate base amount (rate * quantity)
        let amt = (quantity * rate).toFixed(2);

        // Calculate discount - prioritize discount amount over percentage
        let totalDiscountAmount = 0;
        let discountAmount = parseAndFix(item.DiscountAmount);
        let discountPercentage = parseAndFix(item.DiscountPercentage);

        if (discountAmount > 0) {
            // If discount amount is provided, use it directly
            totalDiscountAmount = discountAmount;
        } else if (discountPercentage > 0) {
            // If only percentage is provided, calculate discount amount from total
            totalDiscountAmount = (parseAndFix(amt) * discountPercentage) / 100;
        }

        // Calculate taxable amount after discount
        let taxableAmount = (parseAndFix(amt) - totalDiscountAmount).toFixed(2);

        // Calculate GST amounts
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3) {
            igstAmount = ((parseAndFix(taxableAmount) * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((parseAndFix(taxableAmount) * cgstRate) / 100).toFixed(2);
            sgstAmount = ((parseAndFix(taxableAmount) * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(taxableAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            DiscountAmount: totalDiscountAmount.toFixed(2),
            TaxableAmount: taxableAmount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),
        };
    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));


        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === "object") {
            name = e.target.name;
            value = e.target.value; // Keep as string to allow user to type freely
        } else {
            name = inputType;
            value = e;
        }

        setInvoicedeatils((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            const rate = parseFloat(currentItem.Rate) || 0;
            const qty = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * qty;

            // --- Two-way Discount Calculation ---
            if (name === "DiscountPercentage") {
                currentItem.DiscountPercentage = value;

                const discPercent = parseFloat(value);
                if (!isNaN(discPercent)) {
                    currentItem.DiscountAmount = ((amount * discPercent) / 100).toFixed(2);
                } else {
                    currentItem.DiscountAmount = "";
                }
            }
            else if (name === "DiscountAmount") {
                currentItem.DiscountAmount = value; // let user type freely
                // Don't automatically calculate percentage when typing discount amount
                // The percentage will be calculated only when the field loses focus
            }
            else {
                currentItem[name] = value;
            }

            // Update in array
            updatedDetails[index] = currentItem;

            // --- Recalculate all items ---
            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                parseAndFix(formData.FreightAmount),
                parseAndFix(formData.PackingAmount),
                parseAndFix(formData.TCSAmount),
                parseAndFix(formData.PaidAmount) || 0,
                parseAndFix(formData.CardAmount) || 0,
                parseAndFix(formData.UPIAmount) || 0
            );

            return updatedItemData;
        });
    };

    // New function to handle discount amount blur (when user finishes typing)
    const handleDiscountAmountBlur = (e, index) => {
        const value = e.target.value;

        setInvoicedeatils((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            const rate = parseFloat(currentItem.Rate) || 0;
            const qty = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * qty;

            const discAmt = parseFloat(value);
            if (!isNaN(discAmt) && amount > 0) {
                // Calculate percentage only when user finishes typing
                currentItem.DiscountPercentage = ((discAmt / amount) * 100).toFixed(2);
            } else if (value === "" || isNaN(discAmt)) {
                currentItem.DiscountPercentage = "";
            }

            // Update in array
            updatedDetails[index] = currentItem;

            // --- Recalculate all items ---
            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                parseAndFix(formData.FreightAmount),
                parseAndFix(formData.PackingAmount),
                parseAndFix(formData.TCSAmount),
                parseAndFix(formData.PaidAmount) || 0,
                parseAndFix(formData.CardAmount) || 0,
                parseAndFix(formData.UPIAmount) || 0
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'PaidAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = invoicedeatils.map((item) => calculateItemData(item, updatedFormData));
        setInvoicedeatils(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('PaidAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.MasterId) {
            setErrorMessage('Customer is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.StoreLocationId) {
            setErrorMessage('Store Location is required !');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Purchase: formData,
            PurchaseDetails: invoicedeatils
        };

        // Validate form data here if needed

        postData('PurchaseReturnApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = invoicedeatils.filter((_, i) => i !== itemToDeleteIndex);
            setInvoicedeatils(updatedItemList);
            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            closeConfirmDialog();
        }
    };

    const [itemsOptions, setItemsrOptions] = useState([]);

    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemsOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            // const quantity = parseFloat(modalData.Quantity) || 0;
            const quantity = '1';
            const rate = parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, gstrate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, gstrate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                HSNCode: selectedOption ? selectedItemDetail.HSNCode : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: amount,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                Quantity: quantity,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                Quantity: '',
            });
        }
    };

    const handleModalInputChange = (event) => {
        const { name, value } = event.target;

        // Prevent negative quantity
        if (name === 'Quantity' && parseFloat(value) < 0) {
            alert('Quantity cannot be negative');
            return;
        }

        setModalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }

        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
    });

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        // Prevent duplicate item with same rate
        const duplicateExists = invoicedeatils.some(
            item => item.ItemId === modalData.ItemId && parseFloat(item.Rate) === parseFloat(modalData.Rate)
        );

        if (duplicateExists) {
            setErrorMessageModel("This item with the same rate is already added.");
            return;
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            //setSelectedItems(updatedInvoicedetailsSorted);

            const updatedItemData = updatedInvoicedetailsSorted.map((item) => calculateItemData(item, formData));

            setInvoicedeatils(updatedItemData);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                Quantity: '',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
                BalanceStock: '0',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);

            let FreightAmount = parseFloat(formData.FreightAmount) || 0;
            let PackingAmount = parseFloat(formData.PackingAmount) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount);
        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }

    };

    useEffect(() => {
        fetchData('PurchaseReturnApi', `/Purchase/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    //setInvoicedeatils(response.response_data.PurchaseDetails);
                    const purchaseDetails = response.response_data.PurchaseDetails
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                        BillDate: formattedDate,
                        ClearingDate: formattedDate,
                    }));


                    const updatedItemData = purchaseDetails.map((item) => calculateItemData(item, formData));
                    setInvoicedeatils(updatedItemData);

                    const totals = updatedItemData.reduce(
                        (acc, item) => {
                            acc.Quantity += parseAndFix(item.Quantity);
                            acc.Amount += parseAndFix(item.Amount);
                            acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                            acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                            acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                            acc.TotalAmount += parseAndFix(item.TotalAmount);
                            return acc;
                        },
                        { Quantity: 0, Amount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
                    );

                    const Freight = parseAndFix(formData.Freight);
                    const Packing = parseAndFix(formData.Packing);
                    const TCSAmount = parseAndFix(formData.TCSAmount);
                    const DiscountAmount = parseAndFix(formData.DiscountAmount);
                    const PaidAmount = parseAndFix(formData.PaidAmount);

                    totalCalculation(
                        totals.Quantity,
                        totals.Amount,
                        totals.CGSTAmount,
                        totals.SGSTAmount,
                        totals.IGSTAmount,
                        totals.TotalAmount,
                        TCSAmount,
                        DiscountAmount,
                        Freight,
                        Packing,
                        PaidAmount
                    );
                }
            })
            .catch((error) => {
                console.error('Error fetching Purchase Details:', error);
            });
    }, [id]);

    const [searchQuery, setSearchQuery] = useState('');

    const filteredData = invoicedeatils.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    // â”€â”€ shared input style â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const inp = {
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: "7px",
        fontSize: "12px",
        height: "28px",
        width: "100%",
        padding: "0 8px",
        outline: "none",
        backgroundColor: "#fafafa",
        boxSizing: "border-box",
        transition: "border-color 0.2s",
    };
    const inpR = { ...inp, textAlign: "right" };

    // â”€â”€ card wrapper â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const card = {
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
        border: "1px solid rgba(0,0,0,0.06)",
        marginBottom: "10px",
        overflow: "hidden",
    };
    const cardHead = (color = "#2dd4bf") => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
        backgroundColor: `${color}18`,
        fontSize: "10px",
        fontWeight: 700,
        color: "#1a2e2e",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    });
    const cardBody = { padding: "10px 12px" };
    const lbl = { fontSize: "9.5px", fontWeight: 700, color: "#5a7a7a", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: "3px" };

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif", fontSize: "12px", width: "100%", padding: "6px 6px 6px", boxSizing: "border-box", backgroundColor: "#f0f4f4" }}>

            {/* â”€â”€ Page header card â”€â”€ */}
            <div style={{ ...card, marginBottom: "10px", overflow: "visible" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", flexWrap: "wrap", gap: "8px" }}>
                    {/* Title */}
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>    
                        <span style={{ fontSize: "15px", color: "#2dd4bf" }}>↩️</span>                    
                        <span style={{ fontWeight: 800, fontSize: "13px", color: "#1a2e2e", fontFamily: "Inter, sans-serif" }}>Purchase Return Create</span>
                    </div>

                    {/* Supplier info */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontSize: "11px", fontWeight: 600, color: "#5a7a7a", whiteSpace: "nowrap" }}>
                            Supplier:
                            {formData.InvoiceTypeName && <span style={{ color: "#2dd4bf", marginLeft: "6px" }}>({formData.InvoiceTypeName})</span>}
                        </span>
                        <input
                            type="text"
                            name="SupplierName"
                            value={formData.SupplierName || ''}
                            onChange={handleChange}
                            readOnly
                            style={{ ...inp, width: "200px" }}
                        />
                        <span style={{ fontSize: "11px", fontWeight: 600, color: "#5a7a7a", whiteSpace: "nowrap" }}>Bill No:</span>
                        <input
                            type="text"
                            name="PurchaseOrderNo"
                            value={formData.PurchaseOrderNo || ''}
                            onChange={handleChange}
                            readOnly
                            style={{ ...inp, width: "120px" }}
                        />
                        <span style={{ fontSize: "11px", fontWeight: 600, color: "#5a7a7a", whiteSpace: "nowrap" }}>Bill Date:</span>
                        <input
                            type="date"
                            name="PurchaseOrderDate"
                            value={formData.PurchaseOrderDate ? formatDateForInput(formData.PurchaseOrderDate) : ''}
                            onChange={handleChange}
                            readOnly
                            style={{ ...inp, width: "130px" }}
                        />
                    </div>

                    {/* Action buttons */}
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <button onClick={handleSubmit} disabled={isLoading}
                            style={{ height: "28px", padding: "0 16px", borderRadius: "7px", border: "none", backgroundColor: "#2dd4bf", color: "#fff", fontWeight: 700, fontSize: "11px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}>
                            {isLoading ? <CircularProgress size={14} style={{ color: "#fff" }} /> : "💾"} Save
                        </button>
                        <Link to="/PurchaseReturnIndex" onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{ height: "28px", padding: "0 14px", borderRadius: "7px", border: "1px solid rgba(0,0,0,0.12)", backgroundColor: "#fff", color: "#5a7a7a", fontWeight: 600, fontSize: "11px", cursor: "pointer", display: "flex", alignItems: "center", textDecoration: "none" }}>
                            ← Back
                        </Link>
                    </div>
                </div>
            </div>

            {/* â”€â”€ Error message â”€â”€ */}
            {errorMessage && (
                <div style={{ marginBottom: "8px", padding: "6px 12px", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "7px", fontSize: "11px", color: "#ef4444" }}>
                    {errorMessage}
                </div>
            )}

            {/* â”€â”€ Bill details card â”€â”€ */}
            <div style={card}>
                <div style={cardHead()}>Bill Details</div>
                <div style={{ ...cardBody, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: "10px" }}>
                    <div><label style={lbl}>Bill Date</label><input type="date" name="BillDate" value={formData.BillDate || ''} onChange={handleChange} style={inp} /></div>
                    <div><label style={lbl}>Bill Number <span style={{ color: "#ef4444" }}>*</span></label><input type="text" name="BillNumber" value={formData.BillNumber || ''} onChange={handleChange} readOnly style={inp} placeholder="Bill No" /></div>
                    <div>
                        <label style={lbl}>Freight <span style={{ color: "#8b5cf6", marginLeft: 4 }}>({formData.FreightGSTRate}%)</span><span style={{ color: "#ef4444", marginLeft: 4 }}>{formData.FreightGSTAmount}</span></label>
                        <input type="number" name="FreightAmount" value={formData.FreightAmount || ''} onChange={handleChange} style={inpR} />
                    </div>
                    <div>
                        <label style={lbl}>Packing <span style={{ color: "#8b5cf6", marginLeft: 4 }}>({formData.PackingGSTRate}%)</span><span style={{ color: "#ef4444", marginLeft: 4 }}>{formData.PackingGSTAmount}</span></label>
                        <input type="number" name="PackingAmount" value={formData.PackingAmount || ''} onChange={handleChange} style={inpR} />
                    </div>
                    <div><label style={lbl}>TCS</label><input type="number" name="TCSAmount" value={formData.TCSAmount || ''} onChange={handleChange} style={inpR} /></div>
                    <div><label style={lbl}>Round Off</label><input type="number" name="RoundOff" value={formData.RoundOff || ''} onChange={handleChange} style={inpR} /></div>
                    <div><label style={lbl}>Total</label><input type="number" name="TotalAmount" value={formData.TotalAmount || ''} onChange={handleChange} style={{ ...inpR, fontWeight: 700, color: "#0D47A1" }} /></div>
                    <div><label style={lbl}>Cash</label><input type="number" name="PaidAmount" value={formData.PaidAmount || ''} onChange={handleChange} max={formData.TotalAmount} min="0" style={{ ...inpR, fontWeight: 700, color: "#0D47A1" }} /></div>
                    <div>
                        <label style={lbl}>Balance</label>
                        <input type="text" name="BalanceAmount" value={formData.BalanceAmount || ''} readOnly onChange={handleChange}
                            style={{ ...inpR, fontWeight: 700, color: parseFloat(formData.BalanceAmount) > 0 ? "#ef4444" : "#1a2e2e", backgroundColor: "#f8fafa" }} />
                    </div>
                    <div style={{ gridColumn: "span 2" }}>
                        <label style={lbl}>Store Location</label>
                        <Select
                            options={storeLocationOptions.map((s) => ({ value: s.Id, label: s.Name }))}
                            value={selectedStoreLocation}
                            onChange={(selected) => {
                                setSelectedStoreLocation(selected);
                                setFormData((prev) => ({ ...prev, StoreLocationId: selected ? selected.value : null }));
                            }}
                            isClearable isSearchable placeholder="Store Location"
                            menuPortalTarget={document.body}
                            styles={{
                                control: (b) => ({ ...b, minHeight: "28px", height: "28px", fontSize: "12px", borderRadius: "7px", borderColor: "rgba(0,0,0,0.12)" }),
                                valueContainer: (b) => ({ ...b, height: "28px", padding: "0 8px" }),
                                indicatorsContainer: (b) => ({ ...b, height: "28px" }),
                                menuPortal: (b) => ({ ...b, zIndex: 2000 }),
                                menu: (b) => ({ ...b, fontSize: "12px" }),
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* â”€â”€ Summary bar â”€â”€ */}
            <div style={card}>
                <div style={{ ...cardBody, display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px" }}>
                    {[["Amount", formData.Amount], ["Discount", formData.DiscountAmount], ["Taxable", formData.TaxableAmount], ["CGST", formData.CGSTAmount], ["SGST", formData.SGSTAmount], ["IGST", formData.IGSTAmount]].map(([label, val]) => (
                        <div key={label} style={{ fontSize: "11px", color: "#5a7a7a" }}>{label}: <strong style={{ color: "#B71C1C" }}>{val}</strong></div>
                    ))}
                </div>
            </div>

            {/* â”€â”€ Item entry card â”€â”€ */}
            <div style={card}>
                <div style={cardHead("#6366f1")}>Add Item</div>
                <div style={{ ...cardBody, display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 220px" }}>
                        <AsyncSelect cacheOptions loadOptions={fetchItemOptions} value={selectedItemOption} onChange={handleChangeDrop}
                            placeholder="Search itemâ€¦" isSearchable menuPortalTarget={document.body}
                            styles={{
                                control: (b) => ({ ...b, minHeight: "28px", height: "28px", fontSize: "12px", borderRadius: "7px", borderColor: "rgba(0,0,0,0.12)" }),
                                valueContainer: (b) => ({ ...b, height: "28px", padding: "0 8px" }),
                                indicatorsContainer: (b) => ({ ...b, height: "28px" }),
                                menuPortal: (b) => ({ ...b, zIndex: 2000 }),
                                menu: (b) => ({ ...b, fontSize: "12px" }),
                            }}
                        />
                    </div>
                    <input type="number" name="Quantity" value={modalData.Quantity} onChange={handleModalInputChange} placeholder="Qty" style={{ ...inpR, width: "90px", flex: "0 0 90px" }} />
                    <input type="number" name="Rate" value={modalData.Rate} onChange={handleModalInputChange} placeholder="Rate" style={{ ...inpR, width: "110px", flex: "0 0 110px" }} />
                    <button onClick={saveModalData} style={{ height: "28px", padding: "0 16px", borderRadius: "7px", border: "none", backgroundColor: "#6366f1", color: "#fff", fontWeight: 700, fontSize: "11px", cursor: "pointer" }}>+ Add</button>
                    {errorMessageModel && <span style={{ fontSize: "11px", color: "#ef4444" }}>{errorMessageModel}</span>}
                </div>
            </div>

            {/* â”€â”€ Delete confirm modal â”€â”€ */}
            <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ padding: "24px", backgroundColor: "white", borderRadius: "12px", width: "320px", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.15)" }}>
                    <div style={{ fontSize: "32px", marginBottom: "8px" }}>ðŸ—‘ï¸</div>
                    <strong style={{ fontSize: "13px" }}>Delete this item?</strong>
                    <p style={{ fontSize: "12px", color: "#5a7a7a", margin: "8px 0 16px" }}>This row will be removed from the list.</p>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                        <button onClick={handleDelete} style={{ padding: "6px 20px", borderRadius: "7px", border: "none", backgroundColor: "#ef4444", color: "#fff", fontWeight: 700, fontSize: "12px", cursor: "pointer" }}>Delete</button>
                        <button onClick={closeConfirmDialog} style={{ padding: "6px 20px", borderRadius: "7px", border: "1px solid #e5e7eb", backgroundColor: "#fff", color: "#5a7a7a", fontWeight: 600, fontSize: "12px", cursor: "pointer" }}>Cancel</button>
                    </div>
                </div>
            </Modal>

            {/* â”€â”€ Items table card â”€â”€ */}
            <div style={card}>
                <div style={cardHead("#1F2A38")}>Items ({filteredData.length})</div>
                <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                        <thead style={{ backgroundColor: "#1F2A38", color: "#fff", position: "sticky", top: 0 }}>
                            <tr>
                                {["#", "Item", "Orig.Qty", "Ret.Qty", "Rate", "Amount", "Disc%", "Discâ‚¹", "Taxable", "GSTâ‚¹", "Total"].map((h, i) => (
                                    <th key={i} style={{ padding: "6px 4px", textAlign: i > 1 ? "right" : "left", fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
                                    <td style={{ padding: "3px 6px", textAlign: "center", whiteSpace: "nowrap" }}>
                                        {index + 1}
                                        <DeleteIcon style={{ color: "#ef4444", cursor: "pointer", marginLeft: "6px", fontSize: "14px", verticalAlign: "middle" }} onClick={() => openConfirmDialog(index)} />
                                    </td>
                                    <td style={{ padding: "3px 4px", minWidth: "160px", fontWeight: 600 }}>{item.ItemName}</td>
                                    {/* Original (Sold) Quantity - read only */}
                                    <td style={{ padding: "2px", width: "70px" }}>
                                        <input
                                            type="number"
                                            value={item.SaledQuantity || 0}
                                            readOnly
                                            style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: "#f8fafa" }}
                                        />
                                    </td>
                                    {/* Return Quantity */}
                                    <td style={{ padding: "2px", width: "70px" }}>
                                        <input
                                            type="number"
                                            value={item.Quantity}
                                            name="Quantity"
                                            onChange={(e) => {
                                                const newValue = parseInt(e.target.value, 10);
                                                if (newValue <= item.SaledQuantity) {
                                                    handleCalculation(e, index, 'Quantity');
                                                }
                                            }}
                                            onClick={(e) => e.target.select()}
                                            max={item.SaledQuantity}
                                            style={{ ...inpR, height: "24px", borderRadius: "4px" }}
                                        />
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input type="number" value={item.Rate || 0} name="Rate" onChange={(e) => handleCalculation(e, index, "Rate")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} />
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input value={item.Amount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: "#f8fafa" }} />
                                    </td>
                                    <td style={{ padding: "2px", width: "80px" }}>
                                        <input type="number" value={item.DiscountPercentage || 0} name="DiscountPercentage" onChange={(e) => handleCalculation(e, index, "DiscountPercentage")} style={{ ...inpR, height: "24px", borderRadius: "4px" }} />
                                    </td>
                                    <td style={{ padding: "2px", width: "90px" }}>
                                        <input type="number" inputMode="decimal" step="any" value={item.DiscountAmount ?? ""} name="DiscountAmount" onChange={(e) => handleCalculation(e, index, "DiscountAmount")} onBlur={(e) => handleDiscountAmountBlur(e, index)} style={{ ...inpR, height: "24px", borderRadius: "4px" }} />
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input value={item.TaxableAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: "#f8fafa" }} />
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input value={(parseFloat(item.CGSTAmount || 0) + parseFloat(item.SGSTAmount || 0) + parseFloat(item.IGSTAmount || 0)).toFixed(2)} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: "#f8fafa", width: "65%" }} />
                                        <span style={{ marginLeft: "3px", color: "#8b5cf6", fontSize: "10px" }}>{item.GSTRate ? parseFloat(item.GSTRate) : 0}%</span>
                                    </td>
                                    <td style={{ padding: "2px", width: "100px" }}>
                                        <input value={item.TotalAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", backgroundColor: "#f8fafa", fontWeight: 700, color: "#b45309" }} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* â”€â”€ Remarks card â”€â”€ */}
            <div style={card}>
                <div style={cardHead("#f59e0b")}>ðŸ“ Remarks</div>
                <div style={cardBody}>
                    <textarea name="Remarks" value={formData.Remarks || ''} onChange={handleChange} rows={2}
                        style={{ border: "1px solid rgba(0,0,0,0.12)", borderRadius: "7px", fontSize: "12px", width: "100%", padding: "6px 8px", resize: "vertical", outline: "none", backgroundColor: "#fafafa", boxSizing: "border-box" }} />
                </div>
            </div>

        </div>
    );
}

export default PurchaseReturnCreate;
